import { default as actionsEn } from './messages/actions/en.json'
import { default as actionsEs } from './messages/actions/es.json'
import { default as actionsJa } from './messages/actions/ja.json'
import { default as modalsEn } from './messages/modals/en.json'
import { default as modalsEs } from './messages/modals/es.json'
import { default as modalsJa } from './messages/modals/ja.json'
import { default as detailsEn } from './messages/details/en.json'
import { default as detailsEs } from './messages/details/es.json'
import { default as detailsJa } from './messages/details/ja.json'

const en = { ...actionsEn, ...modalsEn, ...detailsEn }
const es = { ...actionsEs, ...modalsEs, ...detailsEs }
const ja = { ...actionsJa, ...modalsJa, ...detailsJa }

const messages = { en, es, ja }

export default messages
